import React, { Component } from 'react'
import { widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import MDEditor from '@uiw/react-md-editor'
import { Button, Modal } from 'react-bootstrap'
import JobOptions from './JobOptions'
import CompanyDetails from './CompanyDetails'
const styles = {
	input: {
		width: '272px',
		marginTop: '5px',
	},
	range: {
		width: '135px'
	}
}

export default class JobDetails extends Component {

	constructor(props) {
		super(props)
		this.state = {
			jobTitle: '',
			jobDescription: '',
			jobSummary: '',
			selectedQualification: '',
			selectedOtherQualification: '',

			selectedJobCategory: '',
			selectedSkills: [],
			readMoreLink: '',
			positionID: '',
			jobOptions: {},
			workType: this.props.workType,
			jobTypes: this.props.jobType,
			syncToWordpress: props.contentSelectedLangVal == 'En' ? false : true,
			disableSyncToWordPress: false,
			permalink: '',
			permalinkEdited: false,
			isEdited: false,
			qualificationModalVisible: false,
			categoryModalVisible: false,
			skillModalVisible: false,
			companyDetails: {
				contactName: '',
				contactEmail: '',
				contactMobileNumber: '',
				displayMobileNumberInJobPost: '',
				companyName: '',
				companyBio: '',
				companyRegisteredAddress: '',
				companyWebsite: '',
				jobImages: '',
			},
			selectedExperience: '',
			selectedSalary: '',
			selectedJobSector: '',
			noOfOpenings: '',
			markDownEditor: false,
			// editContent: false,
			jobDetails: {},


		}
	}
	updateStateData = () => {
		const { syncToWordpressValue } = this.props
		const {
			jobImages,
			jobQualification,
			jobSummary,
			jobSector,
			jobCategory,
			jobSkills,
			positionID,
			readMoreLink,
			workType,
			jobType,
			contactName,
			contactEmail,
			contactMobileNumber,
			companyName,
			companyBio,
			companyRegisteredAddress,
			displayMobileNumberInJobPost,
			companyWebsite,
			experienceRange,
			salaryRange,
			noOfOpenings,


		} = this.props.jobDetails
		console.log(this.props.jobDetails, 'this is job details from jobdetails')
		const jobTitle = this.props.jobDetails[
			(`jobTitle_${this.props.contentSelectedLangVal}`)
		]
		console.log(jobTitle, '====here is the job title')
		const jobDescription = this.props.jobDetails[
			(`jobDescription_${this.props.contentSelectedLangVal}`)
		]
		console.log(experienceRange, 'here is exp===')
		console.log(jobSummary, 'here is the job summmary in 101')

		let wordPressInfoExists =
			this.props.wordPressInfo && Object.keys(this.props.wordPressInfo).length > 0
		console.log(wordPressInfoExists, 'wordPressInfoExists')
		console.log(this.props.wordPressInfo, 'this.props.wordPressInfo')
		this.setState({
			permalink: wordPressInfoExists ? this.props.wordPressInfo.wordPressPermaLink : '',
			// featuredImageId:
			//     this.props.wordPressInfo && Object.keys(this.props.wordPressInfo).length > 0
			//         ? this.props.wordPressInfo.wordPressMediaID
			//             ? parseInt(this.props.wordPressInfo.wordPressMediaID)
			//             : ''
			//         : '',
			syncToWordpress: syncToWordpressValue ? true : this.props.contentSelectedLangVal == 'En' ? false : true,
			jobTitle: jobTitle,
			jobDescription: jobDescription,
			jobSummary: jobSummary,
			readMoreLink: readMoreLink ? readMoreLink : '',
			companyDetails: {
				jobImages: jobImages && jobImages.length > 0 ? jobImages : [],
				contactName: contactName,
				contactEmail: contactEmail,
				contactMobileNumber: contactMobileNumber,
				displayMobileNumberInJobPost: displayMobileNumberInJobPost,
				companyName: this.props.jobDetails.companyName,
				companyBio: this.props.jobDetails.companyBio,
				companyRegisteredAddress: companyRegisteredAddress,
				companyWebsite: companyWebsite,

			},
			selectedQualification: jobQualification,
			selectedJobCategory: jobCategory,
			selectedSkills: jobSkills,
			positionID: positionID,
			workType: workType,
			jobType: jobType,
			selectedExperience: experienceRange,
			selectedJobSector: jobSector,
			selectedSalary: salaryRange,
			noOfOpenings: noOfOpenings,
			editContent: true,
			jobDetails: this.props.jobDetails

		})
	}


	async componentDidMount() {
		console.log(this.props.jobDetails, 'in line 142 inside job details')
		const { editContent } = this.props

		if (!editContent) {
			if (this.props.contentSelectedLangVal == 'Te') {
				this.setState({ syncToWordpress: true })
			} else {
				this.setState({ syncToWordpress: false })

			}
		}
		if (editContent && this.props.jobDetails && Object.keys(this.props.jobDetails).length > 0) {
			console.log(editContent, this.props.jobDetails, "===================106editContent")
			this.updateStateData()
		}
	}
	// componentDidUpdate = (prevProps, prevState) => {
	// 	console.log(prevProps.jobDetails, 'prevProps.jobDetailsprevProps.jobDetails')
	// 	console.log(this.props.jobDetails, 'this.props.jobDetailsthis.props.jobDetails')
	// }
	handleSyncToWordpress = (e) => {
		const syncToWordpress = e.target.checked
		this.props.syncToWordpress && this.props.syncToWordpress(syncToWordpress)
		this.setState({ syncToWordpress })
		if (syncToWordpress && !this.state.permalinkEdited) {
			let permalink = this.state.jobTitle.trim()
			permalink = permalink.replace(/\s+/g, '-').toLowerCase()
			this.setState({ permalink }, () => {
				this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
			})
		}
	}
	handlePermalink = (e) => {
		let permalink = e.target.value
		console.log(permalink, 'here is the perma link')
		this.setState({ permalink, permalinkEdited: true }, () => {
			permalink = permalink.replace(/\s+/g, '-').toLowerCase()
			this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
		})
	}
	handleTitle = (e) => {
		const title = e.target.value
		let permalink = title.trim()
		if (!this.state.permalinkEdited) {
			permalink = permalink.replace(/\s+/g, '-').toLowerCase()
			this.setState({ permalink })
		}
		this.setState({ jobTitle: title, isEdited: true })
		this.props.updateInParent(`jobTitle_${this.props.contentSelectedLangVal}`, title, 'Job')
		this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
	}
	handleJobSummary = (e) => {
		const jobSummary = e.target.value
		console.log(jobSummary, 'here is the jobsummary')
		this.setState({ jobSummary: jobSummary, isEdited: true })
		this.props.updateInParent(`jobSummary`, jobSummary, 'Job')
		// this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
	}
	hastitleError = () => {
		return !this.state.jobTitle
	}
	handleReadMoreLink = (e) => {
		const readMoreLink = e.target.value ? e.target.value.trim() : e.target.value
		this.setState({ readMoreLink: readMoreLink })
		this.props.updateInParent('readMoreLink', readMoreLink, 'Job')
	}
	handleMDCardDescription = (val) => {
		// const mdMatchedLinks = this.extractMDLabels(val)
		this.setState({
			// matchedLinkTexts: mdMatchedLinks,
			jobDescription: val,
			isEdited: true,
		})
		this.props.updateInParent(
			`jobDescription_${this.props.contentSelectedLangVal}`,
			val,
			'Job'
		)
	}
	handleOpenings = (value) => {
		this.setState({ noOfOpenings: value })
		this.props.updateInParent('noOfOpenings', value, 'Job')
	}
	handlePositionID = (value) => {
		this.setState({ positionID: value })
		this.props.updateInParent('positionID', value, 'Job')
	}

	hasCardDescriptionError = () => {
		return !this.state.jobDescription
	}
	renderQualifications = (qualifications) => {
		const { selectedQualification } = this.state
		return (
			<div>
				<label for='label'>Choose Qualifications : </label>
				<div className='row'>
					{selectedQualification ? (
						<div>
							<text for='text'>Selected Qualifications : </text>
							<text>{selectedQualification}</text>
						</div>
					) : null}
				</div>
				<div>
					{qualifications?.map((qualification, qualificationIndex) => (
						<section class='container' key={qualificationIndex}>

							<label
								onClick={() =>
									this.handleQualification(qualification, qualificationIndex)
								}
								for={qualification + qualificationIndex}
							>
								{qualification}
							</label>
						</section>
					))}
				</div>
			</div>
		)
	}
	renderJobCategories = (jobCategories) => {
		const { selectedJobCategory } = this.state
		return (
			<div>
				<label for='label'>Choose Job Category : </label>
				<div className='row'>
					{selectedJobCategory ? (
						<div>
							<text for='text'>Selected Job Category : </text>
							<text>{selectedJobCategory}</text>
						</div>
					) : null}
				</div>
				<div>
					{jobCategories?.map((category, categoryIndex) => (
						<section class='container' key={categoryIndex}>

							<label
								onClick={() =>
									this.handleCategory(category, categoryIndex)
								}
								for={category + categoryIndex}
							>
								{category}
							</label>
						</section>
					))}
				</div>
			</div>
		)
	}
	renderSkills = (skills) => {
		const { selectedSkills } = this.state
		console.log(selectedSkills, 'here is the selectedskills')
		const Skills = selectedSkills && selectedSkills.join('')
		return (
			<div>
				<label for='label'>Choose Skill : </label>
				<div className='row'>
					{selectedSkills && selectedSkills.length > 0 ? (
						<div>
							<text for='text'>Selected Skill : </text>
							<text>{Skills}</text>
						</div>
					) : null}
				</div>
				<div>

					{skills?.map((skill, skillIndex) => (
						<section class='container' key={skillIndex}>

							<label
								onClick={() =>
									this.handleSkill(skill, skillIndex)
								}
								for={skill + skillIndex}
							>
								{skill}
							</label>
						</section>
					))}
				</div>
			</div>
		)
	}
	closeQualificationModal = () => {
		this.setState({ qualificationModalVisible: false })
	}
	closeCategoryModal = () => {
		this.setState({ categoryModalVisible: false })
	}
	closeSkillModal = () => {
		this.setState({ skillModalVisible: false })
	}
	handleQualification = (value, index) => {
		this.setState({ selectedQualification: value, selectedOtherQualification: '' })
		this.props.updateInParent('jobQualification', value, 'Job')

	}
	handleOtherQualification = (value, index) => {
		this.setState({ selectedQualification: value, selectedOtherQualification: value })
		this.props.updateInParent('jobQualification', value, 'Job')

	}
	handleCategory = (value, index) => {
		this.setState({ selectedJobCategory: value })
		this.props.updateInParent('jobCategory', value, 'Job')

	}
	handleSkill = (value, index) => {
		const { selectedSkills } = this.state
		if (!selectedSkills.includes(value)) {
			selectedSkills.push(value)
		} else {
			const index = selectedSkills.indexOf(value)
			selectedSkills.splice(index, 1)
		}
		console.log(value, 'here is the skill')

		this.setState({ selectedSkills: selectedSkills })
		this.props.updateInParent('jobSkills', selectedSkills, 'Job')

	}

	selectedExperienceRange = (value) => {
		console.log(value, 'inside the selected exp range ')
		this.setState({ selectedExperience: value })
		this.props.updateInParent('experienceRange', value, 'Job')
		// console.log(this.state.selectedExperience, value, 'here are the experience and value')

	}
	selectedJobSector = (value) => {
		console.log(value, 'inside the selected exp range ')
		this.setState({ selectedJobSector: value })
		this.props.updateInParent('jobSector', [value], 'Job')
		// console.log(this.state.selectedExperience, value, 'here are the experience and value')

	}

	selectedSalaryRange = (value) => {
		console.log('inside salary range')
		this.setState({ selectedSalary: value })
		this.props.updateInParent('salaryRange', value, 'Job')

	}
	registerCompany = (isNewCompany, details) => {
		//console.log(details, 'details=- registerCompany in job details===========');
		console.log(details, 'inside register company');
		//console.log(this.state.companyDetails, 'details=- company details log in 371');
		this.setState({ companyDetails: details })
		this.props.handleCompanyDetails(isNewCompany, details)

	}
	render() {
		const {
			jobTitle,
			permalink,
			jobSummary,
			syncToWordpress,
			jobDescription,
			qualificationModalVisible,
			categoryModalVisible,
			skillModalVisible,
			jobOptions,
			companyDetails,
			jobDetails,

		} = this.state
		console.log(jobDetails, 'here is the job details')
		console.log(this.props.jobDetails, "==========jobDetailsPropsAtrender")
		const { qualifications, skills, workType, categories, salaryRange, experienceRange, jobType, jobSector } = this.props
		return (
			<div class='row col-md-10'>
				<details>
					<summary>Job Details</summary>
					<div class='content'>
						{!this.state.disableSyncToWordPress ? (
							<div>
								<input
									disabled={this.state.disableSyncToWordPress}
									type='checkbox'
									onChange={(e) => {
										this.handleSyncToWordpress(e)
									}}
									checked={syncToWordpress}
								/>
								<label style={{ marginLeft: widthPercentageToDP('1') }}>Sync To Website</label>
							</div>
						) : null}

						{console.log(jobTitle, 'here is the jobtitle')}
						<div class='row'>
							<text for='text'>Title :</text>
							<textarea
								type='text'
								onChange={(value) => {
									this.handleTitle(value)
								}}
								value={jobTitle}
								placeholder='Please Enter  Title'
							></textarea>
							{/* {this.hastitleError() ? (
                                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                    Title Cannot Be Empty
                                </text>
                            ) : null} */}
						</div>

						{this.state.syncToWordpress ? (
							<div class='row'>
								<text for='text'>Permalink :</text>
								<textarea
									type='text'
									onChange={(value) => {
										this.handlePermalink(value)
									}}
									value={permalink}
									placeholder='Please Enter  Permalink'
								></textarea>
							</div>
						) : null}
						<div class='row'>
							<text for='text'>PositionID :</text>
							<input
								type='text'
								onChange={(e) => {
									this.handlePositionID(e.target.value)
								}}
								value={this.state.positionID}
								placeholder='Please Enter  PositionID'
							></input>
							{/* {this.hastitleError() ? (
                                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                    Title Cannot Be Empty
                                </text>
                            ) : null} */}
						</div>

						{console.log(jobDescription, 'here is job description')}

						{/* <div class='row'>
                            <text for='text'>Read More Link :</text>
                            <input
                                type='text'
                                onChange={(e) => {
                                    this.handleReadMoreLink(e)
                                }}
                                value={this.state.readMoreLink}
                                placeholder='Please Enter  Read More Link'
                            ></input>
                        </div> */}
						<div class='row'>
							<text for='text'>Description :</text>
							<MDEditor
								preview={this.state.markDownEditor ? 'live' : 'edit'}
								value={jobDescription}
								onChange={(value) => this.handleMDCardDescription(value)}
							/>
							{/* {this.hasCardDescriptionError() ? (
                                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                    Description Cannot Be Empty
                                </text>
                            ) : null} */}
						</div>
						{console.log(jobSummary, 'here is the job summary')}
						<div class='row'>
							<text for='text'>JobSummary :</text>
							<textarea
								type='text'
								onChange={(value) => {
									this.handleJobSummary(value)
								}}
								value={jobSummary}
								placeholder='Please Enter JobSummary'
							></textarea>
							{/* {this.hastitleError() ? (
                                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                    Title Cannot Be Empty
                                </text>
                            ) : null} */}
						</div>
						<div class='row'>
							<label
								onClick={() => {
									this.setState({ qualificationModalVisible: true })
								}}
							>
								Choose Qualifications
							</label>
							<input
								type='text'
								onClick={() => {
									this.setState({ qualificationModalVisible: true })
								}}
								value={this.state.selectedQualification}
								placeholder='Choose Qualifications'
							></input>
						</div>
						<div class='row'>
							<label
								onClick={() => {
									this.setState({ categoryModalVisible: true })
								}}
							>
								Choose Job Category
							</label>
							<input
								type='text'
								onClick={() => {
									this.setState({ categoryModalVisible: true })
								}}
								value={this.state.selectedJobCategory}
								placeholder='Choose Category'
							></input>
						</div>
						<div class='row'>
							<label
								onClick={() => {
									this.setState({ skillModalVisible: true })
								}}
							>
								Choose Skills
							</label>
							<input
								type='text'
								onClick={() => {
									this.setState({ skillModalVisible: true })
								}}
								value={this.state.selectedSkills}
								placeholder='Choose Skills'
							></input>
						</div>
						<div class='row' style={{ marginBottom: 5, display: 'inline' }}>
							<text>No Of Openings : </text>
							<input style={styles.input}
								type='text'
								onChange={(e) => this.handleOpenings(e.target.value)}
								value={this.state.noOfOpenings}
							// placeholder='Choose Category'
							></input>
						</div>
						{console.log(experienceRange, "here is the experience")}
						<div class='row' style={{ marginBottom: 5, display: 'inherit' }}>
							<text>Experience : </text>
							<div class='range'>
								<select
									value={this.state.selectedExperience}
									onChange={(e) => {
										this.selectedExperienceRange(e.target.value)
									}}
								>
									{experienceRange.map((item, index) => {
										return (
											<>
												<option className='choose-option' value='' selected disabled hidden>choose experience</option>
												<option value={item} selected={this.state.selectedExperience == item ? true : false}>
													{item}
													{console.log(item, '===item')}
												</option>
											</>
										)
									})}
								</select>
							</div>
						</div>
						<div class='row' style={{ marginBottom: 5, display: 'inherit' }}>
							<text>JobSector : </text>
							<div class='range'>
								<select
									value={this.state.selectedJobSector}
									onChange={(e) => {
										this.selectedJobSector(e.target.value)
									}}
								>
									{jobSector.map((item, index) => {
										return (
											<>
												<option className='choose-option' value='' selected disabled hidden>choose jobSector</option>
												<option value={item} selected={this.state.selectedJobSector == item ? true : false}>
													{item}
													{console.log(item, '===item')}
												</option>
											</>
										)
									})}
								</select>
							</div>
						</div>

						<div>
							<div class='row' style={{ marginBottom: 5, display: 'inherit' }}>
								<text>Salary : </text>
								<div class='range'>
									<select
										value={this.state.selectedSalary}
										onChange={(e) => {
											this.selectedSalaryRange(e.target.value)
										}}
									>
										{salaryRange.map((item, index) => {
											return (
												<>
													<option value='' selected disabled hidden>choose salary</option>
													<option value={item} selected={this.state.selectedSalary == item ? true : false}>
														{item}
													</option>
												</>
											)
										})}
									</select>
								</div>
							</div>

						</div>

						<Modal show={qualificationModalVisible} onHide={() => this.closeQualificationModal()}>
							<Modal.Body>{this.renderQualifications(qualifications)}</Modal.Body>
							<Modal.Footer>
								<text>Other : </text>
								<input style={styles.input}
									type='text'
									onChange={(e) => this.handleOtherQualification(e.target.value)}
									value={this.state.selectedOtherQualification}
								// placeholder='Choose Category'
								></input>
								<Button onClick={() => this.closeQualificationModal()}>Ok</Button>

							</Modal.Footer>
						</Modal>
						<Modal show={categoryModalVisible} onHide={() => this.closeCategoryModal()}>
							<Modal.Body>{this.renderJobCategories(categories)}</Modal.Body>
							<Modal.Footer>
								<Button onClick={() => this.closeCategoryModal()}>Ok</Button>
							</Modal.Footer>
						</Modal>
						<Modal show={skillModalVisible} onHide={() => this.closeSkillModal()}>
							<Modal.Body>{this.renderSkills(skills)}</Modal.Body>
							<Modal.Footer>
								<Button onClick={() => this.closeSkillModal()}>Ok</Button>
							</Modal.Footer>
						</Modal>
						{console.log(this.props.locations, 'here is the location in render 1')}
						<JobOptions
							// enableCreateContent={this.props.enableCreateContent}
							workType={workType}
							jobTypeOptions={jobType}
							locations={this.props.locations}
							updateInParent={this.props.updateInParent}
							jobDetailsAtEdit={this.props.jobDetails}
							isEditContent={this.props.editContent}

						/>
						{console.log(this.props.jobDetails, 'here is the company edit in line 616')
						}
						{/* <CompanyDetails 
							data={this.state.companyDetails}
						/> */}

						<CompanyDetails
							editContent={this.props.editContent}
							// companyDetailsFromProps={this.props.companyDetails}
							companyDetails={this.state.companyDetails}
							registerCompany={this.registerCompany}
							updateInParent={this.props.updateInParent}
							jobDetailsAtEdit={this.props.jobDetails}
						/>
					</div>

				</details>
			</div>
		)
	}
}